// src/lib/phone.js
//
// Small, deliberately generic phone-number helpers. The business phone
// comes from Admin > Website Settings as a plain display string (e.g.
// "02 8000 1080") - these convert it into a real tel: href without
// assuming that exact number or format, so a future phone-number change
// in Admin produces a working tel: link automatically instead of needing
// a matching manual href somewhere in source.

/**
 * formatPhoneDisplay
 * Currently a passthrough - the settings value is already the
 * human-facing display format an admin typed in. Kept as a named
 * function (rather than using settings.phone directly everywhere) so
 * display-formatting rules can change in one place later if needed.
 */
export function formatPhoneDisplay(phone) {
  return phone || "";
}

/**
 * formatPhoneHref
 * Builds a tel: URI from whatever display format the admin entered.
 * Assumes Australian local numbers (a leading 0) unless the value
 * already looks like it has a country code, since every Horizon number
 * seen so far is domestic - adjust here if that ever changes.
 */
export function formatPhoneHref(phone) {
  if (!phone) return "";
  const digits = phone.replace(/[^\d+]/g, "");
  if (!digits) return "";
  if (digits.startsWith("+")) return `tel:${digits}`;
  if (digits.startsWith("0")) return `tel:+61${digits.slice(1)}`;
  return `tel:${digits}`;
}
